'use strict';
import 'moment-duration-format';
import React, {Component} from 'react';
import {DateHeaderView} from './DateHeaderView';

export class DateHeaderComponent extends Component {
  render() {
    return (
      <DateHeaderView {...this.props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/lists/DateHeader/DateHeaderComponent.js